import React from 'react';
import { Box, Typography, Paper, Container, Link, List, ListItem, ListItemText } from '@mui/material';
import MainLayout from '../../components/layout/MainLayout';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mt: 3, fontWeight: 'bold' }}>
            Effective Date: April 22, 2025
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect only the following:
          </Typography>
          <List sx={{ pl: 4, mb: 2 }}>
            <ListItem sx={{ display: 'list-item', listStyleType: 'disc', py: 0.5 }}>
              <ListItemText primary="Information provided during registration (e.g., name, email, school)." />
            </ListItem>
            <ListItem sx={{ display: 'list-item', listStyleType: 'disc', py: 0.5 }}>
              <ListItemText primary="Math problem answers submitted by students." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            We do <Box component="span" sx={{ fontWeight: 'bold' }}>not</Box> collect cookies, analytics, or third-party tracking data.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            2. How We Use Information
          </Typography>
          <Typography variant="body1" paragraph>
            The information you provide is used solely to:
          </Typography>
          <List sx={{ pl: 4, mb: 2 }}>
            <ListItem sx={{ display: 'list-item', listStyleType: 'disc', py: 0.5 }}>
              <ListItemText primary="Register students for the league and competitions." />
            </ListItem>
            <ListItem sx={{ display: 'list-item', listStyleType: 'disc', py: 0.5 }}>
              <ListItemText primary="Track submissions and generate scores." />
            </ListItem>
            <ListItem sx={{ display: 'list-item', listStyleType: 'disc', py: 0.5 }}>
              <ListItemText primary="Communicate with participants about upcoming events." />
            </ListItem>
          </List>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            3. Data Sharing
          </Typography>
          <Typography variant="body1" paragraph>
            We <Box component="span" sx={{ fontWeight: 'bold' }}>do not</Box> sell, rent, or share your personal data with third parties.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We take reasonable precautions to protect your information from loss, misuse, or unauthorized access.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            5. Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            MathWiz League is intended for students. We recommend that minors use the site under the supervision of a parent
            or guardian.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            6. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You may request access to or deletion of your personal data by contacting us.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, color: 'primary.main' }}>
            7. Contact
          </Typography>
          <Typography variant="body1" paragraph>
            For any privacy-related questions, contact us at{' '}
            <Link href="mailto:contact@mathwizleague.com" underline="hover" color="primary">
              contact@mathwizleague.com
            </Link>.
          </Typography>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default PrivacyPolicyPage;